<template>
    <div class="news">
        <z-filter :name="textLocales.title">
            <z-filter-content
                v-model="filterParams"
                :structure="structure"
                @update-params="onFilterChange"
            />
        </z-filter>

        <div class="news__preloader">
            <z-preloader v-if="isLoading" />
        </div>

        <div class="news__results-wrapper u-top-margin--2xl">
            <div class="news__results-subscription">
                <z-button
                    v-if="lang === 'ru'"
                    tag="a"
                    kind="primary"
                    href="/news-and-media/subscription/"
                    class="news__results-subscription-button"
                    border-radius
                    :size="device === 'mobile' ? 's' : 'm'"
                >
                    {{ textLocales.button }}
                    <template #right>
                        <z-icon name="arrows/round-arrow-big" dir="right"></z-icon>
                    </template>
                </z-button>
            </div>
            <results :data="items" v-if="items.length"/>

            <z-not-found class="news__not-found" v-else-if="!isLoading"></z-not-found>
        </div>


        <z-pagination
            :data="paginationData"
            :loading="isLoading"
            :show-more="{text: textLocales.showMore}"
            @change-page="onPageChange"
            class="u-top-margin--xl-important"
        />
    </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue'
import { getNews } from '@/api/news'
import { localize } from '@/utils/i18n'
import { useGetData } from '@/composable/useGetData'
import { useGetter } from '@/composable/useGetter'
import { useFiltersParams } from '@/composable/useFilter';
import { useHandlers } from '@/views/News/composable/useHandlers'
import Results from './components/Results.vue'

const params = ref({})
const { app } = useGetter(['app'])
const {device} = useGetter(['device'])
const isMore = ref(false)
const appData = app.value.components?.news
const lang = app.value.page.lang
const { isLoading, data, fetcher } = useGetData(getNews, params, appData)

const { onPageChange, onUpdateParams, onFilterChange } = useHandlers(params, isMore, fetcher)

const textLocales = {
    title: localize({
        ru: 'Фильтр',
        en: 'Filter',
        cn: '筛选条件'
    }),
    showMore: localize({
        ru: 'Показать еще',
        en: 'Show more',
        cn: '显示更多'
    }),
    qTitle: localize({
        ru: 'Поиск',
        en: 'Search',
        cn: '搜索'
    }),
    qPlaceholder: localize({
        ru: 'По&nbsp;названию и&nbsp;описанию',
        en: 'Name',
        cn: '按名称'
    }),
    themeTitle: localize({
        ru: 'По теме',
        en: 'Topic',
        cn: '按主题'
    }),
    all: localize({
        ru: 'Все',
        en: 'All',
        cn: '全部'
    }),
    dateTitle: localize({
        ru: 'По периоду',
        en: 'Period',
        cn: '时期'
    }),
    button: localize({
        ru: 'Подписаться на рассылку',
        en: 'Subscribe',
        cn: 'Subscribe'
    })
}

const paginationData = computed(() => {
    return ({
        currentPage: data.value.nav?.current || 0,
        totalItems: data.value.nav?.count || 0,
        totalPages: data.value.nav?.total || 0,
        pageRange: 1
    })
})

const items = ref(data.value.items || [])

const structure = {
    q: {
        type: 'z-input',
        value: '',
        props: {
            title: textLocales.qTitle,
            placeholder: textLocales.qPlaceholder,
            size: 'm',
            icon: 'tools/magnifier',
            'icon-position': 'right',
        },
        class: 'col-default-12'
    },
    theme: {
        type: 'z-select',
        value: '',
        props: {
            title: textLocales.themeTitle,
            size: 'm',
            placeholder: textLocales.all,
            options: appData.filter['theme']
        },
        class: 'col-default-8 col-v-tablet-12'
    },
    date: {
        type: 'z-date-picker',
        value: '',
        props: {
            title: textLocales.dateTitle,
            size: 'm',
            range: true,
            'is-filter': true
        },
        class: 'col-default-4 col-v-tablet-12'
    },
}

const filterParams = useFiltersParams(structure);

watch(data, () => {
    if (!(data.value.items && data.value.items.length)) {
        items.value = []
        return
    }

    items.value = isMore.value ? [...items.value, ...data.value.items] : items.value = data.value.items
})
</script>


<style lang="scss">
.news {
    &__preloader{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__results {
        &-subscription{
            margin-bottom: var(--spacer-xl);
            display: flex;
            justify-content: flex-end;
        }
    }

}
</style>
